import * as React from "react";

import { Grid } from "semantic-ui-react";

import { TaskTypes } from "@teamprevent/common/task/taskActions/models";

import { TaskModel } from "../../model";
import { actionableTaskButtons } from "../../../../actionableTask/components/ActionableTaskButtons";

interface Props {
    task: TaskModel;
}

export const TaskTimelineRow: React.FunctionComponent<Props> = (props: Props) => {

    const isCompletedManagerFeedbackOnReportTask = (task: TaskModel) => {
        return task.type === TaskTypes.ManagerFeedbackOnReportTask && task.completed;
    };

    const isCompletedManagerSatisfactionFollowUpQuestionnaireTask = (task: TaskModel) => {
        return task.type === TaskTypes.ManagerSatisfactionFollowUpQuestionnaireTask && task.completed;
    };

    const { task } = props;
    if (task.type === TaskTypes.ManagerRebookingConfirmationEmailTask) {
        return (
            <Grid.Row className="case-timeline-event">
                <Grid.Column mobile={12} computer={4}>{task.description}</Grid.Column>
                <Grid.Column mobile={12} computer={4}>
                    {task.completedDate && <><strong>Completed: </strong>{task.completedDate.format("DD/MM/YY")}</>}
                </Grid.Column>
                <Grid.Column mobile={12} computer={8}> {task.notes && <><strong>Notes: </strong>{task.notes}</>}</Grid.Column >
            </Grid.Row>
        );
    }

    if (task.type === TaskTypes.OhCaseConfidentialityChangedTask || task.type === TaskTypes.EmployeeRecordMergedTask) {
        return null;
    }

    if (isCompletedManagerFeedbackOnReportTask(task) || isCompletedManagerSatisfactionFollowUpQuestionnaireTask(task)) {
        return null;
    }

    return (
        <>
            <Grid.Row className="case-timeline-event">
                <Grid.Column mobile={16} computer={4}>{task.description}</Grid.Column>
                <Grid.Column mobile={16} computer={4}>
                    {task.completedDate && <><strong>Completed: </strong>{task.completedDate.format("DD/MM/YY")}</>}
                </Grid.Column>
                <Grid.Column mobile={16} computer={4}>{task.dueDate && <><strong>Due: </strong>{task.dueDate.format("DD/MM/YY")}</>}</Grid.Column>
                <Grid.Column mobile={16} computer={4} className="case-timeline-button">
                    {actionableTaskButtons[task.type] && actionableTaskButtons[task.type]({
                        id: task.id,
                        caseId: task.caseId,
                        created: task.dateCreated,
                        customerId: task.customer.id,
                        customerName: task.customer.name,
                        employeeId: task.employeeRecord.id,
                        employeeName: task.employeeRecord.name,
                        taskDescription: task.description,
                        taskType: task.type,
                        completed: task.completed,
                        caseSubject: task.caseSubject,
                        cancelled: task.cancelled,
                    })}
                </Grid.Column>
                {(task.type === TaskTypes.DidNotAttendTask && task.notes) && (
                    <Grid.Column mobile={16} computer={16}>
                        <strong>Notes: </strong>{task.notes}
                    </Grid.Column>)}
            </Grid.Row>
        </>
    );
};
